import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import store from './store'
import App from '../App'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login'),
    props:true
  },
  {
    path: '/pickcustomer',
    name: 'PickCustomer',
    component: () => import('@/views/login/PickCustomer'),
  },

  {
    path: '/nodistillery',
    name: 'NoDistillery',
    component: () => import('@/views/login/NoDistillery'),
  },

  {
    path: '/',
    component: App,
    redirect: () => ({name:'InventoryProducts'}),
    children: [
              {
                path: '/userinfo',
                name: 'UserInfo',
                component: () => import('@/views/login/ConfigurationUserInfo'),
                props:true,
              },

              {
                path: '/production',
                component: () => import('@/views/production/Production'),
                children: [{ path: '',
                          name: 'Production',
                          redirect: () => ({name:'ProductionMashing'}),
                        },

                        { path: 'mashing', name:'ProductionMashing', component: () => import('@/views/production/mashing/ProductionMashing')},
                        { path: 'mashes/:mashBillId', name:'ProductionMashes', component: () => import('@/views/production/mashing/ProductionMashes'), props:true},

                        { path: 'distilling', name:'ProductionDistilling', component: () => import('@/views/production/distilling/ProductionDistilling')},
                        { path: 'distilling/:processId', name:'ProductionDistillations', component: () => import('@/views/production/distilling/ProductionDistillations'), props:true},

                        { path: 'blending', name:'ProductionBlending', component: () => import('@/views/production/blending/ProductionBlending')},
                        { path: 'blending/:formulaId', name:'ProductionBlends', component: () => import('@/views/production/blending/ProductionBlends'), props:true},

                    ]
              },

              {
                path: '/inventory',
                component: () => import('@/views/inventory/Inventory'),
                children: [{ path: '',
                          name: 'Inventory',
                          redirect: () => ({name:'InventoryProducts'})
                        },
                        { path: 'products', name:'InventoryProducts', component: () => import('@/views/inventory/products/InventoryProducts')},
                        { path: 'producttransactions/:productId', name:'InventoryProductsTransactions', component: () => import('@/views/inventory/products/InventoryProductsTransactions'),props:true},

                        { path: 'items', name:'InventoryItems', component: () => import('@/views/inventory/items/InventoryItems')},
                        { path: 'itemtransactions/:itemId', name:'InventoryItemsTransactions', component: () => import('@/views/inventory/items/InventoryItemsTransactions'),props:true},

                        { path: 'spirits', name:'InventorySpirits', component: () => import('@/views/inventory/spirits/InventorySpirits')},
                        { path: 'spirittransactions/:spiritId', name:'InventorySpiritsTransactions', component: () => import('@/views/inventory/spirits/InventorySpiritsTransactions'),props:true},

                        { path: 'wines', name:'InventoryWine', component: () => import('@/views/inventory/wines/InventoryWines')},
                        { path: 'winetransactions/:wineId', name:'InventoryWinesTransactions', component: () => import('@/views/inventory/wines/InventoryWinesTransactions'),props:true},

                    ]
              },

              {
                path: '/documents',
                component: () => import('@/views/documents/Documents'),
                name: 'Documents'
              }


    ]}

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.name === 'Login' || to.name === 'PickCustomer' || to.name === 'NoDistillery') {
    next();
    return;
  }

  // If no token, need to login
  const token = await Vue.prototype.$auth.getTokenSilently();
  if (!token) {
    Vue.prototype.$auth.login();
    return;
  }

  // If no user info (e.g. a browser refresh), then fetch it from the OAUTH server
  if (store.state.user == null) {
    store.commit('setUser', Vue.prototype.$auth.getIdTokenClaims());
    await store.dispatch('refreshCompanies');
}

  // If no company for the user, login
  if (!store.state.customerId) {
    if (store.state.companies.length === 1) {
      store.commit('setCustomerId', store.state.companies[0].customerId);
      next();
    }
    else if (store.state.companies.length > 1)
      next({name:'PickCustomer'});
    else if (store.state.companies.length === 0)
      next({name:'NoDistillery'});
    else
      next({name:'Login'});
    return;
  }

  next();
})

export default router